import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type TypeUiState = {
    navbarExpanded: boolean;
    openBranches: string[];
    recentPaths: string[];
    calendarHidden: string[];
};

const initialState: TypeUiState = {
    navbarExpanded: true,
    openBranches: [],
    recentPaths: [],
    calendarHidden: [],
};

const RECENT_LIMIT = 5;

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleNavbar(state) {
            state.navbarExpanded = !state.navbarExpanded;
        },
        setNavbarExpanded(state, action: PayloadAction<boolean>) {
            state.navbarExpanded = action.payload;
        },
        toggleBranch(state, action: PayloadAction<string>) {
            const id = action.payload;
            state.openBranches = state.openBranches.includes(id)
                ? state.openBranches.filter((item) => item !== id)
                : [...state.openBranches, id];
        },
        focusBranches(state, action: PayloadAction<string[]>) {
            state.openBranches = action.payload;
        },
        recordVisit(state, action: PayloadAction<string>) {
            const path = action.payload;
            state.recentPaths = [path, ...state.recentPaths.filter((item) => item !== path)].slice(0, RECENT_LIMIT);
        },
        toggleCalendar(state, action: PayloadAction<string>) {
            const hidden = state.calendarHidden ?? [];
            state.calendarHidden = hidden.includes(action.payload)
                ? hidden.filter((id) => id !== action.payload)
                : [...hidden, action.payload];
        },
        showOnlyCalendars(state, action: PayloadAction<{ keep: string[]; all: string[] }>) {
            state.calendarHidden = action.payload.all.filter((id) => !action.payload.keep.includes(id));
        },
    },
});

export const {
    toggleNavbar, setNavbarExpanded, toggleBranch, focusBranches, recordVisit,
    toggleCalendar, showOnlyCalendars,
} = uiSlice.actions;

export default uiSlice.reducer;
